import {Modal, Text} from '@mantine/core';
import {BasicButton} from '@packages/ui';
import type {FC} from 'react';
import {modalConfig} from '../../../../../shared/components/modalConfig';
import {getMailAuthLinkWithParamsHooks} from '../../../../../shared/services/getMailAuthLinkWithParamsHooks';

type Props = {
  opened: boolean;
  onClose: () => void;
  recruitmentItemId: number;
};

export const ArchiveSignUpAppealModal: FC<Props> = ({
  opened,
  onClose,
  recruitmentItemId,
}) => {
  const mailAuthLink = getMailAuthLinkWithParamsHooks({});

  return (
    <Modal
      className="w-[468px]"
      radius={16}
      opened={opened}
      onClose={onClose}
      transitionProps={{transition: 'slide-up'}}
      {...modalConfig}
    >
      <div className="flex flex-col items-center gap-y-12 rounded-16 bg-white p-24">
        <Text className="text-md text-black-1 font-bold text-center">
          エントリーには会員登録(無料)が必要です
        </Text>
        <Text className="text-base text-black-1 w-full">
          会員登録すると、気になる募集のエントリー・締切やToDoの管理・選考体験記の閲覧・Premiumスカウトの受け取りなどができます。登録して、志望企業の締切と選考情報を一元管理しましょう。
        </Text>
        <div className="relative w-full mt-24">
          <div className="absolute bg-white border-accent-1 border-collapse border-[1px] rounded-full top-[-16px] left-[50%] -translate-x-1/2 pt-[3px] pb-[2px] px-12">
            <p className="text-xs font-bold text-accent-1 leading text-center text-nowrap">
              会員限定コンテンツ多数！
            </p>
          </div>
          <BasicButton
            isPrimary={true}
            isLarge={true}
            className="w-full mx-auto"
            label="無料会員登録はこちら"
            dataGtmClick="archive-signup-appeal-modal"
            dataGtmContent={JSON.stringify({
              recruitment_item_id: recruitmentItemId,
            })}
            onClick={() => {
              location.href = mailAuthLink;
            }}
          />
        </div>
      </div>
    </Modal>
  );
};
